import { NavController } from 'ionic-angular';
import { Component } from '@angular/core';
import { SessionService } from './../../../../services/session';
import { LocationsService } from '../../../../services/locations';

@Component({
    selector: 'page-payment-history',
    templateUrl: 'payment-history.html'
})
export class PaymentHistoryPage {

    paymentHistory=[];
    constructor(public sessionService:SessionService,
                public navCtrl:NavController,
                public locationsService: LocationsService) {

        this.sessionService.user.incomes.forEach((payment)=>{
            this.paymentHistory.unshift(payment)
        })
    }

    back(){
        this.navCtrl.pop()
    }

    ionViewDidLoad() {
        window['page'] = 'PaymentHistoryPage'; // for GA
    }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/payment-history/payment-history.ts